import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";

import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";


export class UpdateTotalMultiplerFs extends SimplePresentationRunner {

    private _mainTL: gsap.core.Timeline;
    private _controller: SimplePresentationRunnerController;

    constructor() {
        super();
    }

    public shouldRun(): boolean {
        return (DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.FREESPIN || DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
        //return true;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._mainTL = new TimelineLite();

        this._mainTL.add(DevilsCrossRoad.freespinMpView.updateMpText(DevilsCrossRoad.model.getTotalFsXwin()));
        this._mainTL.add(() => {
            controller.finish();
        });

        if (this._mainTL.duration() == 0) {
            ///this._mainTL.add(gsap.to(this, {duration: 0.01}));
        }
    }

    private skip(controller:SimplePresentationRunnerController):void{
        this._mainTL.totalProgress(1);
    }


}